module.exports = __webpack_public_path__ + "static/Flavor_18AMT90219-8fa5f8888c5e99a2b24bb14d98db1d1c.pdf";